import type { AdminBalanceAdjustmentListVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveBalanceAdjustments = createApiThunk<AdminBalanceAdjustmentListVM[], void>(
  "balanceAdjustments/retrieveBalanceAdjustments",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listBalanceAdjustments();
  },
);
